import { toast } from 'react-toastify';

export const NotifyHelper = {
	Success: (message?: string) => (message ? toast.success(message) : null),
	Error: (message?: string) => (message ? toast.error(message) : null),
	Info: (message?: string) => (message ? toast.info(message) : null),
	Warning: (message?: string) => (message ? toast.warning(message) : null),
};
